import './home.css'

export function App() {
  return <>
    <div className="sidebar">
      Sidebar here v2
    </div>
    <div className="editor" contentEditable>

    </div>
  </>
}